import {
  EStudentResultsViewActions,
  StudentResultsViewActions,
} from '@myStore/student-results-view/student-results-view.actions';
import {
  initialsStudentResultsViewState,
  IStudentResultsViewState,
} from '@myStore/student-results-view/student-results-view.state';

export const studentResultsViewReducers = (
  state = initialsStudentResultsViewState,
  actions: StudentResultsViewActions
): IStudentResultsViewState => {
  switch (actions.type) {
    case EStudentResultsViewActions.GetStudentResultsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EStudentResultsViewActions.GetStudentResultsSuccess:
      return {
        ...state,
        isLoading: false,
        results: actions.payload,
      };
    case EStudentResultsViewActions.GetStudentResultsFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    case EStudentResultsViewActions.ClearStudentResults:
      return {
        ...state,
        results: null,
        errors: null,
      };
    case EStudentResultsViewActions.WorkAppealRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EStudentResultsViewActions.WorkAppealSuccess:
      return {
        ...state,
        isLoading: false,
      };
    case EStudentResultsViewActions.WorkAppealFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    case EStudentResultsViewActions.ClearWorkAppealError:
      return {
        ...state,
        results: null,
        errors: null,
      };
    case EStudentResultsViewActions.CloseWorkAppealRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EStudentResultsViewActions.CloseWorkAppealSuccess:
      return {
        ...state,
        isLoading: false,
      };
    case EStudentResultsViewActions.CloseWorkAppealFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    default:
      return state;
  }
};
